$.fn.swipe = function(options) {
  var self = this;

  var options = options || {};

  var elem = $(this);
  var startX = 0;
  var startY = 0;
  var min = options.min || 50; // minimum swipe distance in pixels

  elem.on('touchstart', function(e) {
    var touches = e.changedTouches[0];

    startX = touches.clientX;
    startY = touches.clientY;
  });

  elem.on('touchend', function(e) {
    var touches = e.changedTouches[0];
    var x = touches.clientX;
    var y = touches.clientY;

    var diffX;
    var horizontal;
    if (x < startX) {
      horizontal = 'swipeleft';
      diffX = startX - x;
    } else {
      horizontal = 'swiperight';
      diffX = x - startX;
    }

    var diffY;
    var vertical;
    if (y < startY) {
      vertical = 'swipeup';
      diffY = startY - y;
    } else {
      vertical = 'swipedown';
      diffY = y - startY;
    }

    if (diffX > min || diffY > min) {
      if (diffX > diffY) {
        elem.trigger(horizontal);
      } else {
        elem.trigger(vertical);
      }
    }
  });

  return self;
};